import React from 'react'
import axios from 'axios'
import { useState, useEffect } from 'react'
import ProductRow from './ProductRow'
import AdminSidebar from './AdminSidebar'
import AddProductModal from './AddProductModal'
import EditProductModal from './EditProductModal'
import AdminNavbar from './AdminNavbar'
const SERVER_URL = process.env.REACT_APP_SERVER_URL


const AdminProducts = () => {
    const [modal, setModal] = useState(false)
    const [emodal, setEmodal] = useState(false)
    const [rerender, setRerender] = useState(0)
    // const alert = (msg, type) => (
    //     <div className={`bg-${type}-200 py-2 px-4 w-full`}>{msg}</div>
    // );
    const [products, setProducts] = useState({});
    const [categories, setCategories] = useState({});
    useEffect(() => {
        axios.get(SERVER_URL + "/api/admin/all-category/",
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization:
                        "Bearer " +
                        JSON.parse(localStorage.getItem("userTokenTime")).token,
                }
            }
        ).then((res) => {
            console.log(res.data.Categories);
            setCategories(res.data.Categories);
        });

    }, [modal, rerender]);

    useEffect(() => {
        axios.get(SERVER_URL + "/api/admin/all-products/",
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization:
                        "Bearer " +
                        JSON.parse(localStorage.getItem("userTokenTime")).token,
                }
            }
        ).then((res) => {
            console.log(res.data.Products);
            setProducts(res.data.Products);
            console.log(products);
        });
        
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [modal, emodal, rerender]);


    const [efData, setEfdata] = useState({
        pId: "",
        pName: "",
        pDescription: "",
        pImages: [],
        pEditImages: [],
        pStatus: "",
        pCategory: "",
        pQuantity: "",
        pPrice: "",
        pOffer: "",
        error: false,
        success: false,
    });

    const deleteProductReq = (pId) => {
        console.log(pId);
        axios.post(SERVER_URL +
            "/api/admin/delete-product",
            { pId: pId },
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization:
                        "Bearer " +
                        JSON.parse(localStorage.getItem("userTokenTime")).token,
                },
            }
        )
            .then((res) => {
                console.log(res.data);
                setRerender((prev) => prev + 1);
            }).catch((e) => {
                console.log(e);
            });
    };

    const editProduct = (pId, product) => {
        setEfdata({
            ...efData,
            pId: pId,
            pName: product.pName,
            pDescription: product.pDescription,
            pImages: product.pImages,
            pStatus: product.pStatus,
            pCategory: product.pCategory,
            pType: product.pType,
            pQuantity: product.pQuantity,
            pPrice: product.pPrice,
            pOffer: product.pOffer,
        });
        setEmodal(true);
    };
    
    return (
        <div>
            <AdminNavbar />
            <div className='panel__container'>
                <AdminSidebar activeTab={3} />

                <AddProductModal categories={categories} modal={modal} setModal={setModal} />
                <EditProductModal categories={categories} emodal={emodal} setEmodal={setEmodal} efData={efData} setEfdata={setEfdata} />
                <div style={{ width: "87.5%", padding: "20px", marginLeft: "12.5%" }}>
                    <div className='outer__container'>
                        <div>
                            <div>
                                <div className="addcat__button"
                                    onClick={() => setModal(true)}

                                >
                                    <svg className="w-6 h-6 text-gray-100 mr-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z" clip-rule="evenodd"></path></svg>
                                    Add Product
                                </div>
                            </div>
                        </div>
                        <div className='inner__container2' style={{ padding: "1.5rem", marginTop: "1.5rem" }}>
                            <div style={{ height: "10px" }}></div>

                            <table className="border w-100 my-2">
                                <thead>
                                    <tr>
                                        <th className="px-4 py-2 border">Product</th>
                                        <th className="px-4 py-2 border">Description</th>
                                        <th className="px-4 py-2 border">Image</th>
                                        <th className="px-4 py-2 border">Type</th>
                                        <th className="px-4 py-2 border">Status</th>
                                        <th className="px-4 py-2 border">Stock</th>
                                        <th className="px-4 py-2 border">Price</th>
                                        <th className="px-4 py-2 border">Category</th>
                                        <th className="px-4 py-2 border">Discount</th>
                                        <th className="px-4 py-2 border">Created at</th>
                                        <th className="px-4 py-2 border">Updated at</th>
                                        <th className="px-4 py-2 border">Actions</th>
                                    </tr>

                                </thead>
                                <tbody className='cat__row'>
                                    {products && products.length > 0 ? (
                                        products.map((item, key) => {
                                            return (
                                                <ProductRow
                                                    product={item}
                                                    editProduct={(pId, product, type) =>
                                                        editProduct(pId, product, type)
                                                    }
                                                    deleteProduct={(pId) => deleteProductReq(pId)}
                                                    key={key}
                                                />
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td
                                                colSpan="7"
                                                className="text-xl text-center py-8"
                                            >
                                                No Product found
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                            <div className="text-sm text-gray-600 mt-2" style={{ color: "gray", marginTop: "0.5rem", textAlign: "left" }}>
                                Total {products && products.length} Product found
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default AdminProducts